import React from 'react'
import WhatsappSessionPreview from './WhatsappSessionPreview'

function upper(value) {
  return String(value || '').trim().toUpperCase()
}

function fieldLink(context, linkName) {
  const fields = context && context.formDefinition && context.formDefinition.steps
    && context.formDefinition.steps[0] && context.formDefinition.steps[0].fields
  if (!Array.isArray(fields) || !linkName) return ''
  for (let i = 0; i < fields.length; i++) {
    const f = fields[i]
    if (f && f.linkName === linkName && f.link) return f.link
  }
  return ''
}

export default function ChatbotSessionPreviewAdapter({ formData, context }) {
  const fd = formData || {}
  const headerType = upper(fd.headerType || 'NONE')
  let mediaLink = fd.mediaLink || ''
  if (!mediaLink) {
    if (headerType === 'IMAGE') mediaLink = fd.imageLink || fieldLink(context, 'imageLink')
    else if (headerType === 'VIDEO') mediaLink = fd.videoLink || fieldLink(context, 'videoLink')
    else if (headerType === 'DOCUMENT') mediaLink = fd.attachmentsLink || fieldLink(context, 'attachmentsLink')
  }
  const session = Object.assign({}, fd, {
    headerType,
    mediaLink,
    media: fd.media || fd.image || fd.video || fd.attachment || '',
    fileName: fd.fileName || '',
    bodyText: fd.bodyRichText ? '' : (fd.bodyText || ''),
    bodyRichText: fd.bodyRichText || '',
    footerText: fd.footerText || '',
  })
  if (upper(session.interactivityType) === 'BUTTON') {
    for (let i = 1; i <= 3; i++) {
      const text = String(session['button' + i + 'Text'] || '').trim()
      const type = String(session['button' + i + 'Type'] || '').trim()
      if (text && !type) {
        session['button' + i + 'Type'] = 'QUICK_REPLY'
      }
    }
  }
  if (upper(session.interactivityType) === 'LIST') {
    for (let i = 1; i <= 10; i++) {
      const title = String(session['row' + i + 'Title'] || '').trim()
      if (!title) break
      if (!String(session['row' + i + 'Id'] || '').trim()) {
        session['row' + i + 'Id'] = 'row' + i
      }
    }
  }
  return <WhatsappSessionPreview formData={session} context={context} />
}
